import { Alert, Button, Col, Form, Image, Input, Modal, Row, Table, Upload, Switch } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';

function ListBannerPopup() {
    const token = useSelector((state) => state.user.token);
    const titlePage = 'Banner Popup';

    const [data, setData] = useState([]);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [image, setImage] = useState(null);
    const [file, setFile] = useState(null);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');
    const [form] = Form.useForm();

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });

    // ============================
    // COLUMNS
    // ============================
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            render: (text, record, index) => (page.pagination.current - 1) * 10 + index + 1,
        },
        {
            title: 'Nama Banner',
            dataIndex: 'Name',
            key: 'Name',
        },
        {
            title: 'Gambar',
            dataIndex: 'Image',
            key: 'Image',
            render: (text, record) => (
                <Image
                    width={80}
                    height={80}
                    style={{ objectFit: 'contain' }}
                    src={record.Image}
                    fallback="https://placehold.co/100x100?text=No+Image"
                />
            ),
        },
        {
            title: 'Link',
            dataIndex: 'Link',
            key: 'Link',
            render: (text) => (
                <a href={text} target="_blank" rel="noreferrer">
                    {text}
                </a>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Button
                        type="primary"
                        style={{ marginRight: 10 }}
                        onClick={() => openModal('edit', record)}
                    >
                        <EditOutlined /> Ubah
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={() => modalDeleteData(record)}
                    >
                        <DeleteOutlined /> Hapus
                    </Button>
                </>
            ),
        },
    ];

    // ============================
    // FETCH DATA
    // ============================
    useEffect(() => {
        getApi(`/bannerpopup?isActive=true&search=${search}&page=${page.pagination.current}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), search, isAlert]);

    const getApi = (url) => {
        setLoading(true);
        const dataReq = {
            method: 'GET',
            url: url,
            data: {
                headers: { Authorization: 'Bearer ' + token },
            },
        };
        apiCall(dataReq)
            .then((res) => {
                if (res.status === 200) {
                    setData(res.data.rows);
                    setPage({
                        ...page,
                        pagination: {
                            ...page.pagination,
                            total: res.data.count,
                        },
                    });
                } else {
                    modalError(res.message);
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
    };

    // ============================
    // POST / PUT / DELETE
    // ============================
    const postApi = (method, values) => {
        setLoading(true);
        setIsAlert(false);
        let url = '/bannerpopup';
        if (method === 'DELETE') url = '/bannerpopup/' + values.BannerPopupId;

        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        };

        apiCall(dataReq)
            .then((res) => {
                setLoading(false);
                if (res.status === 200) {
                    setIsAlert(true);
                    setTextAlert(res.message);
                    closeModal();
                } else {
                    modalError(res.message);
                }
            })
            .catch((e) => {
                setLoading(false);
                console.log(e.message);
            });
    };

    // ============================
    // MODAL HANDLERS
    // ============================
    const openModal = (type, record) => {
        if (type === 'edit') {
            setDataModal(record);
            setImage(record.Image);
            form.setFieldsValue({
                Name: record.Name,
                Link: record.Link,
                IsActive: record.IsActive,
            });
        }
        setIsModal(true);
    };

    const closeModal = () => {
        setIsModal(false);
        setDataModal(null);
        form.resetFields();
        setImage(null);
        setFile(null);
    };

    const modalDeleteData = (record) => {
        Modal.confirm({
            title: 'Konfirmasi',
            content: 'Anda yakin ingin menghapus banner ini?',
            onOk: () => postApi('DELETE', record),
        });
    };

    // ============================
    // UPLOAD HANDLING
    // ============================
    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const uploadImage = (info) => {
        setFile(info.file);
        getBase64(info.file, (url) => setImage(url));
    };

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    // ============================
    // SUBMIT FORM
    // ============================
    const onFinish = (values) => {
        const formData = new FormData();
        for (const name in values) {
            if (values[name] !== undefined && values[name] !== null) {
                formData.append(name, values[name]);
            } else {
                formData.append(name, '');
            }
        }

        if (file) formData.append('BannerImage', file);
        if (dataModal) {
            formData.append('BannerPopupId', dataModal.BannerPopupId);
            formData.append('OldImage', dataModal.Image);
            postApi('PUT', formData);
        } else {
            postApi('POST', formData);
        }
    };

    const handleTableChange = (pagination) => {
        setPage({ pagination });
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: { current: 1, pageSize: 10 },
        });
    };

    // ============================
    // RENDER
    // ============================
    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>

            {isAlert && (
                <Alert
                    message={textAlert}
                    type="success"
                    banner
                    closable
                    afterClose={() => setIsAlert(false)}
                />
            )}

            <h3>Daftar Banner Popup</h3>
            <Row style={{ marginBottom: 10 }}>
                <Col span={8}>
                    <Search
                        placeholder="Cari banner..."
                        allowClear
                        enterButton="Search"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ textAlign: 'right' }}>
                    <Button
                        type="primary"
                        onClick={() => openModal('add')}
                    >
                        <PlusOutlined /> Tambah Banner Popup
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey="BannerPopupId"
            />

            <Modal
                title="Form Banner Popup"
                open={isModal}
                onOk={form.submit}
                onCancel={closeModal}
                okText="Simpan"
            >
                <Form
                    form={form}
                    name="form"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="Name"
                        label="Nama Banner"
                        rules={[{ required: true, message: 'Nama banner kosong!' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="BannerImage"
                        label="Gambar Banner"
                        rules={[{ required: !dataModal, message: 'Gambar harus diisi!' }]}
                    >
                        <Upload
                            listType="picture-card"
                            showUploadList={false}
                            onChange={uploadImage}
                            beforeUpload={() => false}
                        >
                            {image ? (
                                <img
                                    src={image}
                                    alt="banner"
                                    style={{ width: 100, height: 100, borderRadius: 10 }}
                                />
                            ) : (
                                uploadButton
                            )}
                        </Upload>
                    </Form.Item>

                    <Form.Item
                        name="Link"
                        label="Link"
                        rules={[{ required: false }]}
                    >
                        <Input placeholder="https://example.com" />
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
}

export default ListBannerPopup;
